<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        用户基本信息修改
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          plain
          @click="handleSave()"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        >
          关闭
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>

    <!-- 页面主内容：查询列表 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :rules="fdRules"
          :inline="true"
          :validate-on-rule-change="false"
          label-position="right"
          label-width="118px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户基本信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户编码"
                prop="userVO.userCode"
              >
                <span class="c-form__read">
                  {{ fd.userVO.userCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户名称"
                prop="userVO.userName"
              >
                <el-input
                  v-model.trim="fd.userVO.userName"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="userVO.tel"
              >
                <el-input
                  v-model.trim="fd.userVO.tel"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效标志"
                prop="userVO.valid"
              >
                <el-radio-group
                  v-model="fd.userVO.valid"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    有效
                  </el-radio>
                  <el-radio label="N">
                    无效
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="邮箱"
                prop="userVO.email"
              >
                <el-input
                  v-model.trim="fd.userVO.email"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="数据来源"
                prop="userVO.sourceType"
              >
                {{ fd.userVO.sourceTypeName }}
              </el-form-item>
            </el-col>
            <el-col
              v-for="(attrUserItem, index) in attrUserList"
              :key="'attrUser'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrUserItem.attrName"
                :prop="'userVO.attrs.' + attrUserItem.attrKey"
              >
                <template v-if="attrUserItem.enums">
                  <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                    <el-radio-group
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="value in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__select"
                      style="width: 100%;"
                      placeholder=""
                      clearable
                    >
                      <el-option
                        v-for="(value) in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.text"
                        :value="value.id"
                      />
                    </el-select>
                  </template>
                </template>
                <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                  <el-input
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__input"
                    placeholder=""
                  />
                </template>
                <template v-else-if="attrUserItem.attrType === 'Date'">
                  <el-date-picker
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                </template>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户登录账号信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="登录账号"
                prop="userAuthVO.account"
              >
                <span class="c-form__read">
                  {{ fd.userAuthVO.account }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效期起"
                prop="userAuthVO.effectStartDate"
              >
                <el-date-picker
                  v-model="fd.userAuthVO.effectStartDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效期止"
                prop="userAuthVO.effectEndDate"
              >
                <el-date-picker
                  v-model="fd.userAuthVO.effectEndDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>

            <template v-if="fd.capacityVO && fd.capacityVO.valid">
              <el-col
                class="c-form__col c-form__part-title"
                :span="24"
              >
                用户主身份信息
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="身份代码"
                  prop="capacityVO.capacityCode"
                >
                  <span class="c-form__read">
                    {{ fd.capacityVO.capacityCode }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="身份名称"
                  prop="capacityVO.capacityName"
                >
                  <el-input
                    v-model.trim="fd.capacityVO.capacityName"
                    class="c-form__input"
                    placeholder=""
                  />
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="身份有效期起"
                  prop="capacityVO.effectStartDate"
                >
                  <el-date-picker
                    v-model="fd.capacityVO.effectStartDate"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="身份有效期止"
                  prop="capacityVO.effectEndDate"
                >
                  <el-date-picker
                    v-model="fd.capacityVO.effectEndDate"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="所属组织"
                  prop="capacityVO.deptCode"
                >
                  <span class="c-form__read">
                    {{ fd.capacityVO.deptName }}
                  </span>
                </el-form-item>
              </el-col>

              <el-col
                v-for="(attrCapacityItem, index) in attrCapacityList"
                :key="'attrCapacity'+ index"
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  :label="attrCapacityItem.attrName"
                  :prop="'capacityVO.attrs.' + attrCapacityItem.attrKey"
                >
                  <template v-if="attrCapacityItem.enums">
                    <span class="c-form__read">
                      <!-- {{ fd.capacityVO.attrs[attrCapacityItem.attrKey] | enums(attrCapacityItem.enums) }} -->
                      {{ fd.capacityVO.attrs[attrCapacityItem.attrKey+'_name'] }}
                    </span>
                  </template>
                  <template v-else-if="attrCapacityItem.attrType === 'String'">
                    <span class="c-form__read">
                      {{ fd.capacityVO.attrs[attrCapacityItem.attrKey] }}
                    </span>
                  </template>
                  <template v-else-if="attrCapacityItem.attrType === 'Date'">
                    <span class="c-form__read">
                      {{ fd.capacityVO.attrs[attrCapacityItem.attrKey] | date('yyyy-MM-dd') }}
                    </span>
                  </template>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="attrCapacityList.length%2 === 0 ? 12 : 24"
              >
                <el-form-item
                  class="c-form__item"
                  label="是否有效"
                  prop="valid"
                >
                  <el-radio-group
                    v-model="fd.capacityVO.valid"
                    class="c-form__radio-group"
                  >
                    <el-radio label="Y">
                      有效
                    </el-radio>
                    <el-radio label="N">
                      无效
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { userService, allDeptTree } from './user.service';
import { attrUser, attrCapacity } from '../attr.service';

export default {
  name: 'AttrEditUser',
  data () {
    return {
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        /* 表单参数必须写入，无默认值为null，避免页面加载时由于使用了对象里不存在的参数而出现报错信息 */
        // 用户信息
        userVO: {
          email: null, // 邮箱
          locked: 'N', // 是否锁定
          sourceType: '0', // 数据来源
          tel: null, // 联系电话
          userName: null, // 用户名称
          userCode: null, // 用户编码
          valid: 'Y', // 有效标志
          attrs: {} // 扩展字段
        },
        // 用户帐号信息
        userAuthVO: {
          account: null, // 帐号
          effectEndDate: null, // 有效期止
          effectStartDate: null, // 有效期起
          pwd: null // 密码
        },
        // 用户主身份信息 ,
        capacityVO: {
          capacityName: null, // 身份名称
          capacityCode: null, // 身份代码
          deptCode: null, // 身份所属组织/部门
          effectEndDate: null, // 身份有效期止
          effectStartDate: null, // 身份有效期起
          attrs: {} // 扩展字段
        }
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        'userVO.userCode': [
          this.$validUtils.required('用户编码'),
          this.$HMValidator.maxLength('用户编码', 36)
        ],
        'userVO.userName': [
          this.$validUtils.required('用户名称'),
          this.$HMValidator.maxLength('用户名称', 75)
        ],
        'userVO.tel': [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.maxLength('联系电话', 11)
        ],
        'userVO.email': [
          this.$HMValidator.email('邮箱'),
          this.$HMValidator.maxLength('邮箱', 90)
        ],
        'userVO.locked': [this.$validUtils.required('是否锁定')],
        'userVO.valid': [this.$validUtils.required('有效标志')],
        'userVO.idNum': [
          this.$validUtils.required('身份证件号码'),
          this.$HMValidator.IDCard_18('身份证件号码')
        ],
        'userVO.sex': [this.$validUtils.required('性别')],
        'userVO.joinTime': [
          this.$validUtils.required('入职时间'),
          this.$HMValidator.startTime(this, 'fd', 'userVO.leaveTime', ['入职时间', '离职时间'])
        ],
        'userVO.leaveTime': [
          this.$HMValidator.endTime(this, 'fd', 'userVO.joinTime', ['入职时间', '离职时间'])
        ],
        'userAuthVO.account': [
          this.$validUtils.required('登录账号'),
          this.$HMValidator.maxLength('登录账号', 75)
        ],
        'userAuthVO.pwd': [this.$validUtils.required('登录密码')],
        'userAuthVO.effectStartDate': [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'userAuthVO.effectEndDate', ['有效期起', '有效期止'])
        ],
        'userAuthVO.effectEndDate': [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'userAuthVO.effectStartDate', ['有效期起', '有效期止'])
        ],
        'capacityVO.capacityCode': [
          this.$validUtils.required('身份代码'),
          this.$HMValidator.maxLength('身份代码', 36)
        ],
        'capacityVO.capacityName': [
          this.$validUtils.required('身份名称'),
          this.$HMValidator.maxLength('身份名称', 113)
        ],
        'capacityVO.effectStartDate': [
          this.$validUtils.required('身份有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'capacityVO.effectEndDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.effectEndDate': [
          this.$validUtils.required('身份有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'capacityVO.effectStartDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.deptCode': [
          this.$validUtils.required('所属组织')
        ]
      },
      /* 表单校验规则 End */

      deptName: null, // 所属组织名称，用于页面展示

      deptList: [],

      /* 扩展字段 Start */
      attrUserList: [], // 用户
      attrCapacityList: [] // 身份
      /* 扩展字段 End */

    };
  },
  computed: {
    // 获取枚举
    enums () {
      const baseEnums = this.$HMStoreService.getEnums();
      const apiEnumsObj = this.$store.state.apiEnums;
      const apiKey = Object.keys(apiEnumsObj);
      let apiEnums = {};
      apiKey.forEach(_key => {
        apiEnums = Object.assign({}, apiEnums, apiEnumsObj[_key]);
      });
      return Object.assign({}, baseEnums, apiEnums);
    }
  },
  methods: {
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      if (node.childNodes == null || node.childNodes.length === 0) {
        return {
          id: node.nodeCode,
          label: node.nodeName
        };
      }
      return {
        id: node.nodeCode,
        label: node.nodeName,
        children: node.childNodes
      };
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          userService.update(this.fd)
            .then(rsp => {
              this.$alert('修改成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.closeNavTabAndTo({ name: 'attrUserManage', params: { isRefresh: true } }, true);
            })
            .catch(err => {
              console.error('修改保存出错', err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 获取组织机构树
     * @param {*}
     * @return {*}
     */
    getAllDeptTree () {
      allDeptTree()
        .then(rsp => {
          this.deptList = rsp.data;
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    /**
     * @description: 获取扩展字段
     * @param {*}
     * @return {*}
     */
    getAttr () {
      attrUser()
        .then(rsp => {
          this.attrUserList = rsp.data.filter(item => {
            return item.show === 'Y';
          });
          this.attrUserList.map(attrUserItem => {
            this.attrSetToData(attrUserItem, this.fd.userVO.attrs, this.fdRules, 'userVO.attrs.' + attrUserItem.attrKey);
            this.rectifyAttrValue(attrUserItem.attrKey, this.fd.userVO[attrUserItem.attrKey], 'userVO');
          });
        });
      // 获取身份扩展字段
      attrCapacity()
        .then(rsp => {
          this.attrCapacityList = rsp.data.filter(item => {
            return item.show === 'Y';
          });
          this.attrCapacityList.map(attrCapacityItem => {
            this.attrSetToData(attrCapacityItem, this.fd.capacityVO.attrs, this.fdRules, 'capacityVO.attrs.' + attrCapacityItem.attrKey);
            this.rectifyAttrValue(attrCapacityItem.attrKey, this.fd.capacityVO[attrCapacityItem.attrKey], 'capacityVO');
          });
        });
    },
    /**
     * @description: 设置扩展字段到form表单数据、规则中
     * @param {Object} _attr 扩展字段
     * @param {Object} _formVo 表单数据对象
     * @param {Object} _formRules 校验规则对象
     * @param {String} _formRuleAttr 校验规则的属性
     * @return {*}
     */
    attrSetToData (_attr, _formVo, _formRules, _formRuleAttr) {
      this.$set(_formVo, _attr.attrKey, null);
      // 设置扩展字段校验规则
      this.$set(_formRules, _formRuleAttr, []);
      //  若扩展字段有必填标志，添加必填校验
      if (_attr.attrRequired === 'Y') {
        this.$set(_formRules, _formRuleAttr, [
          this.$validUtils.required(_attr.attrName)
        ]);
      }
      // 若扩展字段有自定义的校验规则，添加自定义的校验规则
      if (_attr.patterns) {
        const patterns = (_field, pattern) => {
          return {
            pattern: patterns,
            message: `【${_field}】校验不通过`,
            trigger: ['blur', 'change']
          };
        };
        // 向已有扩展字段校验规则数组末添加自定义校验规则
        this.$set(_formRules[_formRuleAttr], _formRules[_formRuleAttr].length,
          patterns(_attr.attrName, _attr.patterns));
      }
    },
    /**
     * @description: 从获取到的信息中整理扩展字段的值，赋值到扩展字段集合对象中
     * @param {*}
     * @return {*}
     */
    rectifyAttrValue (_attrKey, _keyValue, _keyParent) {
      this.fd[_keyParent].attrs[_attrKey] = _keyValue;
      this.$delete(this.fd[_keyParent], _attrKey);
    },
    /**
     * @description: 初始化用户信息
     * @param {*}
     * @return {*}
     */
    initUserByCode () {
      return userService.getUserInfo(this.fd.userVO.userCode)
        .then(rsp => {
          this.editCapacityVo = true;
          this.fd.userVO = Object.assign({}, this.fd.userVO, rsp.data.userVO);
          this.fd.userAuthVO = Object.assign({}, this.fd.userAuthVO, rsp.data.userAuthVO);
          this.fd.capacityVO = Object.assign({}, this.fd.capacityVO, rsp.data.capacityVO);
          // 特殊处理
          this.SFZZH = this.fd.userVO.SFZZH;
          this.SFTSSPT = this.fd.userVO.SFTSSPT;

          Promise.resolve();
        }).catch(err => {
          console.error('初始化数据出错', err);
          Promise.reject(err);
        }).finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 初始化
     * 1.后台获取用户信息
     * 2.后台获取扩展字段
     * 3.扩展字段添加到表单变量里面，整合扩展字段值到扩展属性对象里面
     * 4.后台获取组织机构
     * @param {*}
     * @return {*}
     */
    async init () {
      this.loading = true;
      await this.initUserByCode();
      this.getAttr();
      // 获取组织机构
      this.getAllDeptTree();
    }
  },
  created () {
    this.loading = true;
    // 获取路由的用户编码
    this.fd.userVO.userCode = this.$route.params.userCode;
    this.init();
  }
};
</script>
